module.exports = __webpack_public_path__ + "static/media/ModernOrgChartCardImage.176721e9.png";